function record(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
/** Check saved data before it becomes a relay payload. The server still authenticates the token. */
export function parseCaptionRelayAuth(tokenJson, userJson) {
    try {
        const token = JSON.parse(tokenJson || 'null');
        const user = JSON.parse(userJson || 'null');
        if (!record(token) || !record(user)
            || typeof token.token !== 'string' || !token.token.trim() || token.token !== token.token.trim()
            || typeof user.id !== 'string' || !user.id.trim() || user.id !== user.id.trim()
            || user.role !== 'captioner'
            || (user.isAuthenticated !== undefined && user.isAuthenticated !== true)
            || (token.role !== undefined && token.role !== 'captioner')
            || (token.userId !== undefined && token.userId !== user.id)) {
            return null;
        }
        return {
            token: token.token,
            userId: user.id,
            role: 'captioner',
            name: typeof user.name === 'string' && user.name.trim() ? user.name : undefined
        };
    }
    catch {
        return null;
    }
}
